/**
 * Persist Smoke Drive expand + pin chrome (session), independent of Messages.
 */

import { createOperatorWorkspaceChrome } from './operatorWorkspaceChrome';

const chrome = createOperatorWorkspaceChrome('lsc.operatorDrive.chrome.v1');

export const readOperatorDriveChrome = chrome.readChrome;
export const writeOperatorDriveChrome = chrome.writeChrome;
export const readOperatorDrivePinnedPosition = chrome.readPinnedPosition;
export const writeOperatorDrivePinnedPosition = chrome.writePinnedPosition;
